import getIn from 'transmute/getIn';
export const getAsyncPreviousMessageHistories = getIn(['previousMessageHistories']);